export const ActionTypes = {
  SET_LOADER_STATUS: 'services/dashboards/oeeEquipmentDashboard/set_loader_status',
  FETCH_OEE_EQUIPMENT: 'services/dashboards/oeeEquipmentDashboard/fetch_oee_equipment',
  SET_OEE_EQUIPMENT: 'services/dashboards/oeeEquipmentDashboard/set_oee_equipment',
  FETCH_EQUIPMENT_TRENDS: 'services/dashboards/oeeEquipmentDashboard/fetch_equipment_trends',
  SET_EQUIPMENT_TRENDS: 'services/dashboards/oeeEquipmentDashboard/set_equipment_trends',
  EDIT_TOOL_CAVITY: 'services/dashboards/oeeEquipmentDashboard/edit_tool_cavity',
  FETCH_TOOL_CAVITY_TABLE: 'services/dashboards/oeeEquipmentDashboard/fetch_tool_cavity_table',
  SET_TOOL_CAVITY_TABLE: 'services/dashboards/oeeEquipmentDashboard/set_tool_cavity_table',
  FETCH_ASSEMBLY_EQUIPMENT_TRENDS: 'services/dashboards/oeeEquipmentDashboard/fetch_assembly_equipment_trends',
  SET_ASSEMBLY_EQUIPMENT_TRENDS: 'services/dashboards/oeeEquipmentDashboard/set_assembly_equipment_trends',
  SET_POINT_ANNOTATION: 'services/dashboards/oeeEquipmentDashboard/point_annotation',
  SET_TREND_CYCLE_LOADER_STATUS: 'services/dashboards/oeeEquipmentDashboard/set_trend_cycle_loader_status',
};

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchOeeEquipment = ({ oeeEquipmentParams }) => ({
  oeeEquipmentParams,
  type: ActionTypes.FETCH_OEE_EQUIPMENT,
});

const editToolCavity = ({ toolCavity }) => ({
  toolCavity,
  type: ActionTypes.EDIT_TOOL_CAVITY,
});

const fetchToolCavityTable = ({ jobId }) => ({
  jobId,
  type: ActionTypes.FETCH_TOOL_CAVITY_TABLE,
});

const setToolCavityTable = ({ toolCavityTable }) => ({
  toolCavityTable,
  type: ActionTypes.SET_TOOL_CAVITY_TABLE,
});

const setOeeEquipment = ({ oeeEquipmentData }) => ({
  oeeEquipmentData,
  type: ActionTypes.SET_OEE_EQUIPMENT,
});

const fetchEquipmentTrends = ({ equipmentTrendParams }) => ({
  equipmentTrendParams,
  type: ActionTypes.FETCH_EQUIPMENT_TRENDS,
});

const setEquipmentTrends = ({ equipmentTrends }) => ({
  equipmentTrends,
  type: ActionTypes.SET_EQUIPMENT_TRENDS,
});

const fetchAssemblyEquipmentTrends = ({ equipmentTrendParams }) => ({
  equipmentTrendParams,
  type: ActionTypes.FETCH_ASSEMBLY_EQUIPMENT_TRENDS,
});

const setAssemblyEquipmentTrends = ({ equipmentTrends }) => ({
  equipmentTrends,
  type: ActionTypes.SET_ASSEMBLY_EQUIPMENT_TRENDS,
});

const setPointAnnotation = ({ annotationParams }) => ({
  annotationParams,
  type: ActionTypes.SET_POINT_ANNOTATION,
});

const setTrendCycleLoader = ({ showTrendCycleLoader }) => ({
  showTrendCycleLoader,
  type: ActionTypes.SET_TREND_CYCLE_LOADER_STATUS,
});

export default {
  setLoader,
  fetchOeeEquipment,
  setOeeEquipment,
  editToolCavity,
  fetchToolCavityTable,
  setToolCavityTable,
  fetchEquipmentTrends,
  setEquipmentTrends,
  fetchAssemblyEquipmentTrends,
  setAssemblyEquipmentTrends,
  setPointAnnotation,
  setTrendCycleLoader,
};
